@if(config.type == 'label'){
<span
  [class]="`avatar text-uppercase fw-semibold text-${config.color}-${contraryThemes[config.theme!]} bg-${config.color}-${config.theme}`"
  [style]="`width: ${avatarSizes[config.size!]}px; height: ${avatarSizes[config.size!]}px;`"
>
  {{ shortLabel(config.label) }}
</span>

} @else {
<span
  class="avatar"
  [style]="`width: ${avatarSizes[config.size!]}px; height: ${avatarSizes[config.size!]}px;`"
>
  <img [src]="`${config.src}`" />
</span>
}
